let HeightToggler = function(){
    return {
        /* Object Methods*/
        init: function(el) {
            // Info: a class named "smooth" is used for transition animation.
            if (!el.hasAttribute('data-height')) {
                el.style.display = 'block';
                el.dataset.height = `${el.offsetHeight}px`;
            }

            el.style.display = 'block';
            el.style.height = 0;

            return el;
        },

        expand: function(el) {
            let elemTarget = this.init(el);
            setTimeout(function() {
                elemTarget.style.height = elemTarget.dataset.height;
            }, 20);
        },

        collapse: function(el) {
            let elemTarget = this.init(el);
            elemTarget.style.height = 0;
        }

    };
};

export default HeightToggler;


// WEBPACK FOOTER //
// ./src/js/components/height-toggler.js